<template>
  <div class="region-select">
    <div class="info-control arr-item" @click="showPal">
      <span>{{ labelName }}</span>
      <span v-show="!isShow"
        >{{ select.province }} {{ select.city }} {{ select.area }}</span
      >
    </div>
    <div class="region-panel" v-if="isShow">
      <v-distpicker
        type="mobile"
        @province="selectProvince"
        @city="selectCity"
        @area="selectArea"
      ></v-distpicker>
    </div>
  </div>
</template>

<script>
import VDistpicker from "v-distpicker";
export default {
  components: {
    VDistpicker
  },
  props: {
    labelName: String,
    select: Object
  },
  data () {
    return {
      isShow: false
    };
  },
  mounted () {
    window.onpopstate = () => {
      if (this.isShow) {
        this.isShow = false;
        history.go(1);
      }
    };
  },
  methods: {
    showPal () {
      this.isShow = true;
    },
    selectProvince (value) {
      this.select.province = value.value
    },
    selectCity (value) {
      this.select.city = value.value
    },
    selectArea (value) {
      this.select.area = value.value
      this.isShow = false
    }
  }
};
</script>

<style lang="scss" scoped>
.region-select {
  .info-control {
    height: 1rem;
    line-height: 1rem;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
  }
  .arr-item {
    padding-right: 0.8rem;
  }
  .arr-item:after {
    right: 0;
  }
  .card-item {
    position: relative;
    .icon {
      position: absolute;
      background: url(../../static/img/choice-success.png) no-repeat;
      background-size: 100% 100%;
      right: 0.8rem;
      top: 0.25rem;
      width: 0.6rem;
      height: 0.6rem;
    }
  }
}
.region-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all 0.6s;
  background-color: #eff3f6;
  overflow: hidden;
  z-index: 9999;
  overflow-y: auto;
  height: 1000px;
}
</style>


// WEBPACK FOOTER //
// AddressSelect.vue?0071f6e4